import { ReactNode, useMemo } from "react";
import { PaletteFragmentFragment } from "src/api/graphql/__generated__/graphql";
import { DefaultPalette } from "src/constants/DefaultPalette";
import PaletteContext, { PaletteContextType } from "../PaletteContext";
import PaletteSyncBackgroundColor from "./PaletteSyncBackgroundColor";

const PaletteWrapper = ({
	palette,
	children,
	syncBackgroundColor,
}: {
	palette?: PaletteFragmentFragment | null;
	children?: ReactNode;
	syncBackgroundColor?: boolean;
}) => {
	const parsedPalette = useMemo<PaletteContextType["palette"]>(() => {
		if (palette?.primary && palette?.secondary && palette?.tertiary) {
			return {
				primary: palette.primary,
				secondary: palette.secondary,
				tertiary: palette.tertiary,
				isFallback: false,
			};
		}
		return {
			...DefaultPalette,
			isFallback: true,
		};
	}, [palette]);

	return (
		<PaletteContext.Provider value={{ palette: parsedPalette }}>
			{syncBackgroundColor && <PaletteSyncBackgroundColor />}
			{children}
		</PaletteContext.Provider>
	);
};
export default PaletteWrapper;
